import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const ITEM_HEIGHT = 48;

export default function LongMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '15ch',
          },
        }}>
        <MenuItem onClick={props.exportToXLS}>Exportar XLS </MenuItem>
        <MenuItem onClick={props.exportToCSV}>Exportar CSV</MenuItem>
        {props.showPdfExport && <MenuItem>{props.exportToPDF()}</MenuItem>}
      </Menu>
    </div>
  );
}

//----------------------------------- PROPTYPES --------------------------------------------------//
LongMenu.propTypes = {
  exportToXLS: PropTypes.func.isRequired,
  exportToCSV: PropTypes.func.isRequired,
  hidePdfExport: PropTypes.bool.isRequired,
  exportToPDF: PropTypes.func,
  showPdfExport: PropTypes.bool,
};
//------------------------------------------------------------------------------------------------//
